// extracted by mini-css-extract-plugin
export var askAiIcon = "_mo-9";
export var container = "_mo-0";
export var groupSeparator = "_mo-a";
export var highlight = "_mo-4";
export var resultIcon = "_mo-5";
export var resultItem = "_mo-7";
export var resultSubtitle = "_mo-3";
export var resultTitle = "_mo-2";
export var resultsList = "_mo-1";
export var searchGroup = "_mo-6";
export var selected = "_mo-8";